module.exports = __webpack_public_path__ + "img/arrow-up-fill.7c80841f.svg";